import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _edb443d2 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _380eb2a5 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _5c9bd5b6 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _2feb7746 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _f602ba7c = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _6f8a9496 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _16e5adc1 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _30fe967b = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _05d42f07 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _447c11fd = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _726a5a32 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _42436d32 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _439c3446 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _f4ad6d98 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _5bee170b = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _86832bec = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _defaf0a0 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _ac0292aa = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _46081b7c = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _4e88bc00 = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _edb443d2,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _380eb2a5,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _5c9bd5b6,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _2feb7746,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _f602ba7c,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _6f8a9496,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _6f8a9496,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _6f8a9496,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _16e5adc1,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _30fe967b,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _05d42f07,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _30fe967b,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _05d42f07,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _447c11fd,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _447c11fd,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _447c11fd,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _447c11fd,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _447c11fd,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _447c11fd,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _447c11fd,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _726a5a32,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _726a5a32,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _42436d32,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _439c3446,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _439c3446,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _f4ad6d98,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _5bee170b,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _86832bec,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _86832bec,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _defaf0a0,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _ac0292aa,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _46081b7c,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _4e88bc00,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
